export const getCampaignsInfoConfig = ({
    clientId,
    startDate,
    endDate,
}) => ({
    url: `/api/clients/${clientId}/campaigns/info/`,
    method: 'GET',
    params: {
        start_date: startDate,
        end_date: endDate,
    },
});
